import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Icon,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import * as XLSX from "xlsx";

const DummySessionsModal = ({ open, onClose, dummySessions }) => {
  const downloadExcel = () => {
    const dataToExport = dummySessions.map((s) => ({
      "Patient Name": s.patientName,
      "Therapist Name": s.therapistName,
      "Time Slot": s.time,
      "Session Name": s.sessionName,
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dummy Sessions");
    XLSX.writeFile(workbook, "Dummy_Sessions_List.xlsx");
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <MDTypography variant="h5">Dummy Sessions List</MDTypography>
          <IconButton onClick={onClose}>
            <Icon>close</Icon>
          </IconButton>
        </MDBox>
      </DialogTitle>
      <DialogContent dividers>
        <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
          <Table>
            <TableHead sx={{ display: "table-header-group" }}>
              <TableRow>
                <TableCell>
                  <b>Patient</b>
                </TableCell>
                <TableCell>
                  <b>Therapist</b>
                </TableCell>
                <TableCell>
                  <b>Time</b>
                </TableCell>
                <TableCell>
                  <b>Session</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dummySessions.map((session, index) => (
                <TableRow key={index}>
                  <TableCell>{session.patientName}</TableCell>
                  <TableCell>{session.therapistName}</TableCell>
                  <TableCell>{session.time}</TableCell>
                  <TableCell>{session.sessionName}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <MDButton onClick={onClose} color="secondary" variant="outlined">
          Close
        </MDButton>
        <MDButton onClick={downloadExcel} color="info" variant="gradient">
          <Icon sx={{ mr: 1 }}>download</Icon>
          Download Excel
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

export default DummySessionsModal;
